import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import StatusPill from '../../../StatusPill';
import SelectionTabs from '../SelectionTabs';
import CredentialsFields from '../CredentialsFields';
import RecipeBlock from '../RecipeBlock';
import { CLIENT_STATUS_UNSUPPORTED, AUTHENTICATION_OPTIONS } from '../../clients/constants';
import { clientShape, sectionShape } from '../../clients/propTypes';
import {
  Wrapper,
  Header,
  TitleRow,
  Title,
  Summary,
  Sections,
  Section,
  SectionTitle
} from './styled';

const ClientRecipe = ({
  client,
  sections,
  authMethod = null,
  credentials,
  messageValues = {},
  onAuthMethodChange,
  onCredentialChange,
  onSelectClient
}) => {
  const intl = useIntl();

  const {
    id,
    label,
    subLabel,
    status,
    summaryId,
    authMethods
  } = client;

  const authOptions = AUTHENTICATION_OPTIONS
    .filter(({ value }) => authMethods.includes(value))
    .map(({ value, labelId }) => ({ value, label: intl.formatMessage({ id: labelId }) }));

  return (
    <Wrapper
      aria-labelledby={ `mcp-client-tab-${id}` }
      id={ `mcp-client-panel-${id}` }
      role="tabpanel"
      tabIndex={ 0 }
    >
      <Header>
        <TitleRow>
          <Title>{subLabel ? `${label} · ${subLabel}` : label}</Title>
          {status === CLIENT_STATUS_UNSUPPORTED && <StatusPill tone="unsupported" />}
        </TitleRow>
        {summaryId && <Summary>{intl.formatMessage({ id: summaryId })}</Summary>}
      </Header>
      {authOptions.length > 1 && (
        <SelectionTabs
          ariaLabel={ intl.formatMessage({ id: 'mcp.auth.ariaLabel' }) }
          onChange={ onAuthMethodChange }
          options={ authOptions }
          value={ authMethod }
        />
      )}
      {authMethod && (
        <CredentialsFields
          authMethod={ authMethod }
          onChange={ onCredentialChange }
          values={ credentials }
        />
      )}
      <Sections>
        {sections.map(({ id: sectionId, titleId, blocks }) => (
          <Section key={ sectionId }>
            {titleId && <SectionTitle>{intl.formatMessage({ id: titleId })}</SectionTitle>}
            {blocks.map((block) => (
              <RecipeBlock
                key={ block.id }
                block={ block }
                messageValues={ messageValues }
                onSelectClient={ onSelectClient }
              />
            ))}
          </Section>
        ))}
      </Sections>
    </Wrapper>
  );
};

ClientRecipe.propTypes = {
  client: clientShape.isRequired,
  sections: PropTypes.arrayOf(sectionShape).isRequired,
  authMethod: PropTypes.string,
  credentials: PropTypes.objectOf(PropTypes.string).isRequired,
  messageValues: PropTypes.objectOf(PropTypes.string),
  onAuthMethodChange: PropTypes.func.isRequired,
  onCredentialChange: PropTypes.func.isRequired,
  onSelectClient: PropTypes.func.isRequired
};

export default ClientRecipe;
